import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M14 16.5v-.77a2.73 2.73 0 0 1 3.27-2.68l3.02.6a1.4 1.4 0 0 0 1.5-2.08l-1.63-2.8a3 3 0 1 0-3.35-4.82",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M16 9h-.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M17 5.12V5a3 3 0 1 0-5.24 2h-1A6.77 6.77 0 0 0 4 13.77C4 16.1 5.9 18 8.23 18H9",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M13 22H4a2 2 0 1 1 0-4h12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M13.67 18c.21-.44.33-.94.33-1.45A3.65 3.65 0 0 0 10.26 13",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "Rat";
const Rat = memo(themed(Icon));
export {
  Rat
};
//# sourceMappingURL=rat.js.map
